module.exports = __webpack_public_path__ + "plan-type--enterprise-nologo.svg";